export class Region {
    id: number;
    code: string;
    name: string;
    state: any;
}